module.exports = __webpack_public_path__ + "static/media/career-office.3eb51e36.svg";